import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_OPERATORS_ID_LOADING = 'GET_OPERATORS_ID_LOADING';
export const GET_OPERATORS_ID_SUCCESS = 'GET_OPERATORS_ID_SUCCESS';
export const GET_OPERATORS_ID_REJECT = 'GET_OPERATORS_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getOperatorsIdLoading = () => ({ type: GET_OPERATORS_ID_LOADING });
export const getOperatorsIdSuccess = (payload) => ({ type: GET_OPERATORS_ID_SUCCESS, payload });
export const getOperatorsIdReject = (payload) => ({ type: GET_OPERATORS_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getOperatorsIdRequest = async ({ id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { IdUser: id },
    }, getState);
    return request(`/Users/web/GetByIdUsers`, options);
};